import { makeStyles } from '@policygenius/mortar';

type Classes = 'track';
interface Options {
  index: number;
}

export default makeStyles<Options, Classes>(({ colors }) => ({
  track: ({ index }) => ({
    position: 'absolute',
    background: index === 1 ? colors.gray200 : colors.orange400,
    height: 5,
    top: 0,
    bottom: 0,
    margin: ['auto', 0],
    borderRadius: 2,
  }),
}));
